// import { useEffect, useState } from "react";
import { RPostHogThrottle } from './index';

export type UTM = {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
};

type PosthogUTMReturnType = {
  utm: UTM;
};

type PosthogUTM = () => PosthogUTMReturnType;

export const getPosthogUTM: PosthogUTM = () => {
  // 检查是否在客户端环境
  const isBrowser = typeof window !== 'undefined';

  // 如果不是浏览器环境，返回空的UTM对象
  if (!isBrowser) {
    return {
      utm: {
        utm_source: 'server',
        utm_medium: 'server',
        utm_campaign: 'server',
        utm_content: 'server',
      },
    };
  }

  const searchParams = new URLSearchParams(window.location.search);
  let newUtm = {
    utm_source: searchParams.get('utm_source') || '',
    utm_medium: searchParams.get('utm_medium') || '',
    utm_campaign: searchParams.get('utm_campaign') || '',
    utm_content: searchParams.get('utm_content') || '',
  };
  const urlHasValue = Object.values(newUtm).some((k) => k);
  if (urlHasValue) {
    RPostHogThrottle('view_after_visit_app', newUtm);
    sessionStorage.setItem('utm', JSON.stringify(newUtm));
    // console.log("view_after_visit_app", newUtm);
  } else {
    const storedUtm = sessionStorage.getItem('utm');
    const parsedUtm = storedUtm ? JSON.parse(storedUtm) : null;
    parsedUtm && (newUtm = parsedUtm);
    // console.log("parsedUtm", newUtm);
  }

  return { utm: newUtm };
};

const GetPosthogUTM = getPosthogUTM();
export const posthogUTM = (from?: string) => {
  return GetPosthogUTM;
};
